import { useMemo } from 'react';

import { Search, type SearchItemComponentType } from '../../../../components/Search';
import { useInputFocusOnMount } from '../../../../hooks/useInputFocusOnMount';
import { useSearch } from '../../useSearchPage';

import type { SearchCopy } from '../../SearchPage';

type Props<Model> = SearchCopy & {
  searchResultListClassName?: string;
  Item: SearchItemComponentType<Model>;
  searchActions?: React.ReactNode;
};

export const SearchInput = <SearchPageOption,>({
  translations,
  noResult,
  searchResultListClassName,
  Item,
  searchActions,
}: Props<SearchPageOption>): JSX.Element => {
  const {
    options,
    selected,
    searchString,
    isLoading,
    hasNoResults,
    hasPagination,
    searchCompanies,
    selectOption,
    showMoreResults,
    mapOptionToId,
  } = useSearch<SearchPageOption>();

  const searchInputRef = useInputFocusOnMount();

  const searchResults = useMemo(() => {
    return options.map((item) => ({
      item: item,
      matches: [],
    }));
  }, [options]);

  return (
    <Search
      name='search-input'
      searchString={searchString}
      selected={selected}
      inputRef={searchInputRef}
      items={searchResults}
      isLoading={isLoading}
      translations={translations}
      onSelect={selectOption}
      onChange={searchCompanies}
      getKey={mapOptionToId}
      Item={Item}
      searchResultListClassName={searchResultListClassName}
      searchActions={searchActions}
      hasNoResults={hasNoResults}
      noResult={noResult}
      showMoreResults={showMoreResults}
      hasPagination={hasPagination}
    />
  );
};
